import { TRANSACTION_TYPE_TAB } from './types'

enum TRANSACTION_TYPE {
  DEPOSIT = 'deposit',
  MINT = 'mint',
  OTC = 'otc',
  PAYMENT = 'payment',
  PAYOUT = 'payout',
  STABLECOIN_DEPOSIT = 'stablecoin_deposit',
  STABLECOIN_SWAP = 'stablecoin_swap',
  STABLECOIN_WITHDRAWAL = 'stablecoin_withdrawal',
  WITHDRAWAL = 'withdrawal',
}

export const FIAT_WALLET_TX_TYPES = [
  TRANSACTION_TYPE.DEPOSIT,
  TRANSACTION_TYPE.WITHDRAWAL,
  TRANSACTION_TYPE.PAYMENT,
  TRANSACTION_TYPE.PAYOUT,
]
export const FUNDING_TX_TYPES = [
  TRANSACTION_TYPE.DEPOSIT,
  TRANSACTION_TYPE.WITHDRAWAL,
  TRANSACTION_TYPE.STABLECOIN_DEPOSIT,
  TRANSACTION_TYPE.STABLECOIN_WITHDRAWAL,
  TRANSACTION_TYPE.MINT,
  TRANSACTION_TYPE.PAYMENT,
  TRANSACTION_TYPE.PAYOUT,
]
export const SWAP_TX_TYPES = [TRANSACTION_TYPE.STABLECOIN_SWAP]
export const OTC_TX_TYPES = [TRANSACTION_TYPE.OTC]

export const getTransactionTypes = (tab: TRANSACTION_TYPE_TAB, selectedTypes: string[]) => {
  if (tab === TRANSACTION_TYPE_TAB.SWAP) {
    return SWAP_TX_TYPES
  }

  if (tab === TRANSACTION_TYPE_TAB.OTC) {
    return OTC_TX_TYPES
  }

  if (selectedTypes.length !== 0) {
    return selectedTypes
  }

  return FUNDING_TX_TYPES
}
